{
  "verse": {
    "loading": "Ayet yükleniyor...",
    "error": "Ayet yüklenemedi",
    "reference": "— {{surah}} Suresi, {{ayah}}. Ayet",
    "arabicUnavailable": "(Arapça mevcut değil)",
    "english": "İngilizce",
    "arabic": "العربية",
    "swapLanguage_aria": "Dili değiştir",
    "toggleLanguage_title": "İngilizce / Arapça arasında geçiş yap",
    "reflect": "Tefekkür et",
    "reflecting": "Düşünülüyor…",
    "reflect_aria": "Bu ayeti niyetinizle ilişkilendiren kişisel bir tefekkür oluşturun",
    "insights": "İçgörüler",
    "insights_aria": "AI Kuran İçgörülerini aç",
    "share": "Paylaş",
    "share_aria": "Bu ayeti görsel olarak paylaş",
    "share_title": "Bu ayeti paylaş",
    "removeFromFavorites_aria": "Favorilerden çıkar",
    "saveToFavorites_aria": "Favorilere kaydet",
    "favoritesProLocked_aria": "Favoriler bir Pro özelliğidir",
    "favoritesUpgrade_aria": "Favorileri kaydetmek için yükseltin",
    "signInToSave": "Favorileri kaydetmek için giriş yapın.",
    "failedToUpdateFavorites": "Favoriler güncellenemedi",
    "couldNotReflect": "Tefekkür oluşturulamadı",
    "shareCaption": "\"{{text}}\"\n— {{surah}} Suresi, {{ayah}}. Ayet\n\nrhemn.com",
    "imageSavedVerseCopied": "Görsel kaydedildi · ayet kopyalandı",
    "imageSaved": "Ayet görseli kaydedildi",
    "couldNotCreateImage": "Görsel oluşturulamadı"
  },
  "insights": {
    "panel_aria": "Kuran İçgörüleri paneli",
    "title": "İçgörüler",
    "reference": "{{surah}} Suresi, {{ayah}}. Ayet",
    "close_aria": "İçgörüler panelini kapat",
    "versePreview_aria": "Ayet önizlemesi",
    "back_aria": "Geri",
    "tryAgain": "Tekrar dene",
    "backTo_aria": "{{ref}} ayetine dön",
    "copyVerse_aria": "{{ref}} kopyala",
    "openingVerse": "Ayet açılıyor…",
    "verseError": "Ayet açılamadı."
  },
  "proGate": {
    "title": "AI Kuran İçgörüleri bir Pro özelliğidir",
    "subtitleSafari": "Rhemn Pro ile her ayetin derin, bağlamsal anlamının kilidini açın. Zaten üye misiniz? Giriş yaptığınızda otomatik olarak açılır.",
    "subtitle": "Her ayetin derin, bağlamsal anlamını keşfedin.",
    "bulletAsk": "Ayet hakkında her soruyu sorun",
    "bulletTafsir": "Anında AI destekli tefsir özetleri",
    "bulletRelated": "Tematik olarak ilgili ayetleri keşfedin",
    "upgrade": "Pro'ya yükselt"
  },
  "ask": {
    "heading": "Sor",
    "suggestion1": "Bu ayetin daha geniş bağlamı nedir?",
    "suggestion2": "Bunu günlük hayatta nasıl uygulayabilirim?",
    "suggestion3": "Klasik alimler bu konuda ne diyor?",
    "placeholder": "Bu ayet hakkında her şeyi sorun…",
    "input_aria": "Bu ayet hakkında bir soru sorun",
    "submit_aria": "Soruyu gönder",
    "submit_title": "Gönder (⌘↵)",
    "submit_label": "Sor",
    "submit_hint": "⌘↵",
    "suggestions_aria": "Önerilen sorular",
    "error": "Yanıt alınamadı.",
    "pending": "Sorunuz üzerine düşünülüyor…",
    "attribution": "AI tarafından oluşturulan yanıt · Ehil alimlerin yerini tutmaz"
  },
  "tafsir": {
    "heading": "Tefsir",
    "emptyText": "Bu ayet için AI tarafından oluşturulmuş bir tefsir özeti alın.",
    "generate": "Tefsir Oluştur",
    "commentary": "Yorum",
    "regenerate": "Yeniden oluştur",
    "regenerate_aria": "Tefsiri yeniden oluştur",
    "attribution": "AI tarafından oluşturulan özet · Ehil alimlerin yerini tutmaz",
    "error": "Tefsir oluşturulamadı.",
    "pending": "Yorum okunuyor…"
  },
  "related": {
    "heading": "İlgili Ayetler",
    "copied": "Kopyalandı: {{ref}}",
    "failedToCopy": "Kopyalanamadı",
    "empty": "İlgili ayet bulunamadı.",
    "error": "İlgili ayetler yüklenemedi.",
    "pending": "İlgili ayetler bulunuyor…"
  },
  "favorites": {
    "panel_aria": "Favori ayetler",
    "title": "Favori Ayetler",
    "proLocked": "Ayet favorileri bir Pro özelliğidir.",
    "loading": "Yükleniyor…",
    "failedToLoad": "Favoriler yüklenemedi",
    "empty": "Henüz favori yok. Kaydetmek için herhangi bir ayetteki kalbe dokunun.",
    "reference": "— {{surah}} Suresi, {{ayah}}. Ayet",
    "remove_aria": "Favorilerden çıkar",
    "failedToRemove": "Çıkarılamadı"
  }
}
